import { IsBoolean, IsNumber, IsOptional, IsString } from 'class-validator';
import { BankSource } from '../enum/source/bank-source';
import { CustomerBrowserData } from '../models/customer-browser/customer-browser-data.model';

export class PaymentRequestDto {
  orderId?: number;
  baseUrl?: string;
  comment?: string;

  /**
   * Specifies should ht card get stored / tokenized
   */
  @IsOptional()
  @IsBoolean()
  storeCard?: boolean;

  /**
   * Card Token
   */
  @IsOptional()
  @IsString()
  cardToken?: string;

  @IsOptional()
  customerBrowserData?: CustomerBrowserData;

  @IsOptional()
  @IsNumber()
  paymentMethodId?: number;

  @IsOptional()
  @IsString()
  paymentSolutionId?: string;

  @IsOptional()
  @IsNumber()
  merchantId: number;

  @IsOptional()
  @IsString()
  source: BankSource;
}
